import React from "react";

export default function ContactInfo2() {
  return (
    <div className="office-google-map-wrapper" style={{ height: "20%" }}>
      {/* <br/>
      <br/>
      <br/>
      <br/> */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62253.764014149674!2d77.69782862590132!3d12.787581802680448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae71e8fcc5626d%3A0xaff1c81a29ca91a!2sV%20MAKE%20INDUSTRIES!5e0!3m2!1sen!2sin!4v1746683035432!5m2!1sen!2sin"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
}
